import { render, staticRenderFns } from "./lottery.vue?vue&type=template&id=c8684fbe&scoped=true"
import script from "./lottery.vue?vue&type=script&lang=js"
export * from "./lottery.vue?vue&type=script&lang=js"
import style0 from "./lottery.vue?vue&type=style&index=0&id=c8684fbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8684fbe",
  null
  
)

export default component.exports